export default __webpack_public_path__ + "static/media/Raza.ffafb7f8.png";